export function calculateARVRow(row, materialOptions) {
  const { parameter, size, method, material, arv, measuredValue, labs } = row;
  let R = 0;
  const ARV = parseFloat(arv) || 0;
  const measured = parseFloat(measuredValue) || 0;
  const Labs = parseInt(labs) || 1;

  let valid = true;
  let reason = '';

  // ---- Parameter validation ----
  if (!['RVP', 'Sulfur', 'Benzene', 'Oxygenate'].includes(parameter)) {
    valid = false;
    reason = `Unsupported parameter "${parameter}"`;
  }
  // ---- Material validation ----
  if (parameter === 'Sulfur' && method === 'D6667') {
    if (material !== 'Butane') {
      valid = false;
      reason = `Material must be "Butane" when Sulfur is tested with D6667`;
    }
  } else {
    if (!materialOptions.some((opt) => opt.value === material)) {
      valid = false;
      reason = `Unsupported material "${material}"`;
    }
  }

  // ---- Reproducibility calculation ----
  if (valid) {
    if (parameter === 'RVP') {
      if (size === '250 mL') {
        R = 0.23;
      } else if (size === '1L') {
        R = 0.01014 * (ARV + 23.2);
      } else {
        valid = false;
        reason = `Unsupported size "${size}" for RVP`;
      }
    } else if (parameter === 'Sulfur') {
      if (method === 'D6667' && material === 'Butane') {
        R = 2.3205 * Math.pow(ARV, 0.7);
      } else {
        R = 0.4273 * Math.pow(ARV, 0.8015);
      }
    } else if (parameter === 'Benzene') {
      R = 0.221 * Math.pow(ARV, 0.67);
    } else if (parameter === 'Oxygenate') {
      R = 0.13 * Math.pow(ARV, 0.83);
    }
  }

  // ---- Delta check ----
  const delta = Number(Math.abs(measured - ARV).toFixed(10));

  const deltaAllowable = R > 0 ? 0.75 * R * Math.sqrt(1 + 1 / Labs) : 0;
  const passFail = delta <= deltaAllowable;

  return {
    ...row,
    reproducibility: R,
    delta,
    deltaAllowable,
    passFail,
    valid,
    reason
  };
}

export function calculateARVRows(rows, materialOptions) {
  const validRows = [];
  const invalidRows = [];

  rows.forEach((row, i) => {
    const calculated = calculateARVRow(row, materialOptions);
    const rowNumber = row.__csvIndex !== undefined ? row.__csvIndex + 2 : i + 1;

    if (calculated.valid) {
      validRows.push({ ...calculated, rowNumber });
    } else {
      invalidRows.push({
        ...row,
        rowNumber,
        reason: calculated.reason || 'Unsupported Parameter|Method|Material|Size combination'
      });
    }
  });

  return { validRows, invalidRows };
}
